import type { RefObject } from '@fullcalendar/core/preact'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'

import SearchIcon from '../../assets/img/search-icon.svg?react'
import { useClickOutside } from '../../hooks/useClickOutside'
import useDebounce from '../../hooks/useDebounce'
import type { ITeamMember } from '../../types/tenant/team.types'

import { UserRoleEnum } from '@/types'
import UserPart from './UserPart'
import { toast } from 'react-toastify'

interface SearchInputWidthDropProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string
    placeholder?: string
    fetchFunk?: any
    selectedItems?: number[]
    selectedRoles?: string[]
    fetchParams?: string
    onlyOneLead?: boolean
    onSelected: (id: ITeamMember) => void
}

const SearchInputWidthDrop = ({
    label,
    placeholder,
    fetchFunk,
    selectedItems,
    onSelected,
    fetchParams,
    selectedRoles,
    onlyOneLead = false,
    ...rest
}: SearchInputWidthDropProps) => {
    const [search, setSearch] = useState('')
    const [options, setOptions] = useState([])
    const [isOpen, setIsOpen] = useState(false)

    const wrapperRef = useClickOutside(() =>
        setIsOpen(false),
    ) as RefObject<HTMLDivElement | null>
    const searchOptions = async () => {
        const res = await fetchFunk(
            `search=${search}${`&${fetchParams}`}`,
        ).unwrap()
        setOptions(res.data)
        setIsOpen(true)
    }
    const debounse = useDebounce((value: string) => {
        setSearch(value)
    }, 300)
    useEffect(() => {
        if (search === '') return
        searchOptions()
    }, [search])

    return (
        <div
            className="form-group input--lg input--icon-left flex-auto "
            ref={wrapperRef}
        >
            {label && <label className="label">{label}</label>}
            <div className="input-wrapper  relative">
                <span className="ico text-color-1">
                    <SearchIcon />
                </span>
                <input
                    className="input input--solid-2 full-radius w-full"
                    type="text"
                    onFocus={({ target }) => {
                        if (options.length > 0) {
                            setIsOpen(true)
                        }
                    }}
                    onChange={({ target }) => debounse(target.value)}
                    placeholder={placeholder}
                    {...rest}
                />
                {isOpen && (
                    <div className="search-drop top-pos">
                        <ul className="search-results-list">
                            {(options as ITeamMember[]).map((el, index) => (
                                <li
                                    className={clsx(`search-results--item`, {
                                        selected:
                                            selectedItems?.includes(el.id) ||
                                            (onlyOneLead &&
                                                el.roles?.includes(
                                                    UserRoleEnum.DISPATCHER,
                                                ) &&
                                                selectedRoles?.includes(
                                                    UserRoleEnum.DISPATCHER,
                                                )) ||
                                            (el.roles?.includes(
                                                UserRoleEnum.EXECUTIVES,
                                            ) &&
                                                selectedRoles?.includes(
                                                    UserRoleEnum.EXECUTIVES,
                                                )),
                                    })}
                                    key={index}
                                    onClick={() => {
                                        console.log(
                                            selectedRoles,
                                            el,
                                            'selectedRoles',
                                        )
                                        if (
                                            onlyOneLead &&
                                            selectedRoles?.includes(
                                                UserRoleEnum.DISPATCHER,
                                            ) &&
                                            el.roles?.includes(
                                                UserRoleEnum.DISPATCHER,
                                            )
                                        ) {
                                            toast.warn(
                                                'Only one lead can be selected',
                                            )
                                            return
                                        }
                                        if (
                                            onlyOneLead &&
                                            selectedRoles?.includes(
                                                UserRoleEnum.EXECUTIVES,
                                            ) &&
                                            el.roles?.includes(
                                                UserRoleEnum.EXECUTIVES,
                                            )
                                        ) {
                                            toast.warn(
                                                'Only one lead can be selected',
                                            )
                                            return
                                        }

                                        onSelected(el)
                                        setIsOpen(false)
                                    }}
                                >
                                    <UserPart
                                        src={el?.photo}
                                        name={el.fullName}
                                        email={el.email}
                                    />
                                </li>
                            ))}
                            {options.length === 0 && (
                                <li className="text-center p-3">No found</li>
                            )}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    )
}

export default SearchInputWidthDrop
